import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { FormListeners } from '../../../../models/beans/form-listeners.abstract';
import { Revisione53State } from '../../../../store/revisione53.reducers';
import { setSchedaCoopTrasportoSpecificListeners } from './coop-trasporto-specific-listeners';

export class CoopTrasportoFormListeners extends FormListeners {
    constructor(form: FormGroup, private readonly store: Store<Revisione53State>) {
        super(form);
    }

    setListeners(): void {
        setSchedaCoopTrasportoSpecificListeners(this.form, this.store);
    }
}
